import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';

import AsyncLoadablePage from 'components/AsyncLoadablePage';

export default function RouteComponent(routeObj) {
  return (
    <Route key={`route-${routeObj.name}`} path={routeObj.path}>
      <AsyncLoadablePage routeObj={routeObj} />
    </Route>
  );
}

RouteComponent.propTypes = {
  path: PropTypes.string.isRequired,
};
